import React from "react";

//REDUX
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import * as reduxActions from "store/actions"
import reduxStore from "store";
import history from "store/history";

// @MATERIAL
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Check from "@material-ui/icons/Check";
import Close from "@material-ui/icons/Close";
import Business from "@material-ui/icons/Business";
import Person from "@material-ui/icons/Person";
import ArrowForward from "@material-ui/icons/ArrowForward";

// core components
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/Button";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import CardHeader from "components/Card/CardHeader";
import Icon from "components/Icon";

// functions
import { translate, customApp } from "functions/";

const useStyles = makeStyles(theme => ({
  container: {
    padding: "30px 15px",
    position: "relative",
    width: "100%"
  },
  pageHeader: {
    textAlign: "center",
    marginBottom: "50px"
  },
  pageSubtitle: {
    marginTop: "10px",
    color: "#777",
    maxWidth: "700px",
    margin: "0 auto",
  },
  planCard: {
    height: "100%",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 15px 30px rgba(0,0,0,0.1)"
    }
  },
  planTitle: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  planPrice: {
    textAlign: "center",
    fontSize: "2rem",
    fontWeight: "bold",
    margin: "15px 0",
    color: customApp("color")
  },
  planDescription: {
    textAlign: "center",
    color: "#777",
    marginBottom: "20px"
  },
  featuresTitle: {
    fontWeight: "bold",
    marginTop: "20px",
    marginBottom: "10px"
  },
  featureItem: {
    display: "flex",
    alignItems: "center",
    margin: "10px 0",
  },
  featureText: {
    marginLeft: "10px"
  },
  featureIcon: {
    minWidth: "24px"
  },
  divider: {
    margin: "20px 0"
  },
  actionButton: {
    marginTop: "20px",
    width: "100%"
  },
  enterpriseHighlight: {
    backgroundColor: customApp("color"),
    color: "#fff",
    padding: "15px",
    borderRadius: "5px",
    marginTop: "20px"
  },
  comparePlans: {
    marginTop: "60px",
    marginBottom: "30px",
    textAlign: "center"
  },
  comparisonTable: {
    width: "100%",
    borderCollapse: "collapse",
    marginTop: "20px",
    "& th, & td": {
      padding: "12px 15px",
      textAlign: "left",
      borderBottom: "1px solid #eee"
    },
    "& th": {
      backgroundColor: "#f8f9fa",
      fontWeight: "bold"
    },
    "& tr:hover": {
      backgroundColor: "#f5f5f5"
    }
  },
  icon: {
    color: customApp("color")
  },
  iconNegative: {
    color: "#999"
  },
  faqSection: {
    marginTop: "60px"
  },
  faqQuestion: {
    fontWeight: "bold",
    margin: "20px 0 10px 0"
  },
  faqAnswer: {
    color: "#555",
    marginBottom: "15px"
  },
  contactSection: {
    marginTop: "60px",
    textAlign: "center",
    padding: "30px",
    backgroundColor: "#f8f9fa",
    borderRadius: "10px"
  }
}));

function PlanFeature({ available, text }) {
  const classes = useStyles();
  return (
    <div className={classes.featureItem}>
      <div className={classes.featureIcon}>
        {available ?
          <Check className={classes.icon} /> :
          <Close className={classes.iconNegative} />
        }
      </div>
      <Typography variant="body2" className={classes.featureText}>
        {text}
      </Typography>
    </div>
  );
}

function Plans(props) {
  const classes = useStyles();
  const { session } = reduxStore.getState();

  const handleUpgrade = () => {
    // Abre formulário de contato ou redirecionamento
    window.open("https://sonne.global/", "_blank");
  };

  const handleConsultative = () => {
    // Abre formulário de contato para consulta
    window.open("https://sonne.global/", "_blank");
  };

  return (
    <div className={classes.container}>
      <div className={classes.pageHeader}>
        <Typography variant="h3" style={{ fontWeight: "bold" }}>
          Planos MACHEN
        </Typography>
        <Typography variant="h6" className={classes.pageSubtitle}>
          Escolha o plano ideal para a sua jornada de transformação digital.
          Desde soluções gratuitas até atendimento empresarial personalizado.
        </Typography>
      </div>

      <GridContainer>
        {/* Plano Gratuito */}
        <GridItem xs={12} sm={12} md={6}>
          <Card className={classes.planCard}>
            <CardHeader>
              <div style={{ display: "flex", justifyContent: "center", margin: "10px 0" }}>
                <Person style={{ fontSize: "48px", color: customApp("color") }} />
              </div>
              <Typography className={classes.planTitle}>
                Plano Gratuito
              </Typography>
              <Typography className={classes.planPrice}>
                R$ 0
              </Typography>
              <Typography className={classes.planDescription}>
                Perfeito para conhecer a plataforma e experimentar funcionalidades básicas
              </Typography>
            </CardHeader>
            <CardBody>
              <Typography className={classes.featuresTitle}>
                Funcionalidades incluídas:
              </Typography>
              <PlanFeature available={true} text="Dashboard básico" />
              <PlanFeature available={true} text="Gerenciamento de tarefas simples" />
              <PlanFeature available={true} text="Acesso para 1 usuário" />
              <PlanFeature available={true} text="Suporte via e-mail" />

              <Divider className={classes.divider} />

              <Typography className={classes.featuresTitle}>
                Limitações:
              </Typography>
              <PlanFeature available={false} text="Planejamento Estratégico" />
              <PlanFeature available={false} text="Biblioteca de documentos" />
              <PlanFeature available={false} text="Sistema de tags avançado" />
              <PlanFeature available={false} text="Calendário integrado" />
              <PlanFeature available={false} text="Chat de equipe" />
              <PlanFeature available={false} text="BRIGHT & CONNECTED" />
              <PlanFeature available={false} text="Suporte prioritário" />

              <Button
                color="primary"
                round
                className={classes.actionButton}
                onClick={() => history.push('/d')}
              >
                Começar Gratuitamente
              </Button>
            </CardBody>
          </Card>
        </GridItem>

        {/* Plano Empresarial */}
        <GridItem xs={12} sm={12} md={6}>
          <Card className={classes.planCard}>
            <CardHeader>
              <div style={{ display: "flex", justifyContent: "center", margin: "10px 0" }}>
                <Business style={{ fontSize: "48px", color: customApp("color") }} />
              </div>
              <Typography className={classes.planTitle}>
                Plano Empresarial
              </Typography>
              <Typography className={classes.planPrice}>
                Personalizado
              </Typography>
              <Typography className={classes.planDescription}>
                Solução completa adaptada às necessidades específicas da sua empresa
              </Typography>
            </CardHeader>
            <CardBody>
              <Typography className={classes.featuresTitle}>
                Personalize a sua MACHEN:
              </Typography>
              <PlanFeature available={true} text="Dashboard avançado e personalizado" />
              <PlanFeature available={true} text="Planejamento Estratégico completo" />
              <PlanFeature available={true} text="Biblioteca de documentos ilimitada" />
              <PlanFeature available={true} text="Sistema de tags avançado" />
              <PlanFeature available={true} text="Calendário integrado" />
              <PlanFeature available={true} text="Chat de equipe em tempo real" />
              <PlanFeature available={true} text="BRIGHT & CONNECTED" />
              <PlanFeature available={true} text="Suporte prioritário 24/7" />
              <PlanFeature available={true} text="Múltiplos usuários (conforme contrato)" />
              <PlanFeature available={true} text="Onboarding e treinamento para equipe" />

              <div className={classes.enterpriseHighlight}>
                <Typography variant="subtitle1" style={{ fontWeight: "bold" }}>
                  Atendimento Consultivo
                </Typography>
                <Typography variant="body2" style={{ marginTop: "5px" }}>
                  Nossa equipe realizará uma análise detalhada das necessidades do seu negócio
                  para oferecer a solução mais adequada, com implementação personalizada
                  e acompanhamento continuo.
                </Typography>
              </div>

              <Button
                color="primary"
                round
                className={classes.actionButton}
                onClick={handleConsultative}
              >
                Solicitar Atendimento <ArrowForward style={{ marginLeft: "5px" }} />
              </Button>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>

      <div className={classes.comparePlans}>
        <Typography variant="h4" style={{ fontWeight: "bold" }}>
          Comparativo Detalhado
        </Typography>

        <table className={classes.comparisonTable}>
          <thead>
            <tr>
              <th>Recursos</th>
              <th>Plano Gratuito</th>
              <th>Plano Empresarial</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Dashboard</td>
              <td>Básico</td>
              <td>Avançado e Personalizado</td>
            </tr>
            <tr>
              <td>Planejamento Estratégico</td>
              <td><Close className={classes.iconNegative} /></td>
              <td><Check className={classes.icon} /></td>
            </tr>
            <tr>
              <td>Biblioteca de documentos</td>
              <td><Close className={classes.iconNegative} /></td>
              <td><Check className={classes.icon} /></td>
            </tr>
            <tr>
              <td>Sistema de tags</td>
              <td><Close className={classes.iconNegative} /></td>
              <td><Check className={classes.icon} /></td>
            </tr>
            <tr>
              <td>Calendário</td>
              <td><Close className={classes.iconNegative} /></td>
              <td><Check className={classes.icon} /></td>
            </tr>
            <tr>
              <td>Chat</td>
              <td><Close className={classes.iconNegative} /></td>
              <td><Check className={classes.icon} /></td>
            </tr>
            <tr>
              <td>BRIGHT & CONNECTED</td>
              <td><Close className={classes.iconNegative} /></td>
              <td><Check className={classes.icon} /></td>
            </tr>
            <tr>
              <td>Usuários</td>
              <td>1</td>
              <td>Múltiplos (conforme contrato)</td>
            </tr>
            <tr>
              <td>Suporte</td>
              <td>E-mail</td>
              <td>Prioritário 24/7</td>
            </tr>
            <tr>
              <td>Onboarding</td>
              <td>Auto-serviço</td>
              <td>Personalizado com treinamento</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className={classes.faqSection}>
        <Typography variant="h4" style={{ fontWeight: "bold", marginBottom: "20px" }}>
          Perguntas Frequentes
        </Typography>

        <Typography variant="h6" className={classes.faqQuestion}>
          Como funciona o plano empresarial?
        </Typography>
        <Typography variant="body1" className={classes.faqAnswer}>
          O plano empresarial da MACHEN é totalmente personalizado. Iniciamos com uma consultoria
          para entender as necessidades específicas do seu negócio, depois montamos uma proposta
          sob medida que atenda exatamente às suas demandas. O valor e as funcionalidades são
          determinados após esta análise.
        </Typography>

        <Typography variant="h6" className={classes.faqQuestion}>
          Posso migrar do plano gratuito para o empresarial?
        </Typography>
        <Typography variant="body1" className={classes.faqAnswer}>
          Sim! A migração é simples e garantimos que todos os seus dados sejam preservados.
          Entre em contato com nossa equipe através do botão "Solicitar Atendimento"
          e iniciaremos o processo de upgrade.
        </Typography>

        <Typography variant="h6" className={classes.faqQuestion}>
          O que é o BRIGHT & CONNECTED?
        </Typography>
        <Typography variant="body1" className={classes.faqAnswer}>
          BRIGHT & CONNECTED é nossa solução premium de conexão e gerenciamento de conhecimento
          empresarial, que integra todos os projetos e equipes em uma interface intuitiva,
          potencializando a colaboração e o compartilhamento de informações estratégicas.
        </Typography>

        <Typography variant="h6" className={classes.faqQuestion}>
          Existe algum compromisso de permanência?
        </Typography>
        <Typography variant="body1" className={classes.faqAnswer}>
          Os termos de contrato são personalizados para cada cliente empresarial,
          mas oferecemos opções flexíveis que se adaptam às necessidades da sua
          empresa. Durante a consultoria, discutiremos as melhores opções para o seu caso.
        </Typography>
      </div>

      <div className={classes.contactSection}>
        <Typography variant="h4" style={{ fontWeight: "bold", marginBottom: "15px" }}>
          Ainda com dúvidas?
        </Typography>
        <Typography variant="body1" style={{ maxWidth: "700px", margin: "0 auto 20px" }}>
          Nossa equipe está pronta para ajudar você a encontrar o plano ideal para o seu negócio.
          Entre em contato conosco para uma conversa personalizada.
        </Typography>
        <Button
          color="primary"
          round
          size="lg"
          onClick={handleConsultative}
        >
          Fale com um Consultor
        </Button>
      </div>
    </div>
  );
}

const mapStateToProps = (store) => ({
  session: store.session
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(reduxActions, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Plans);
